import { ClimbingBoxLoader } from "react-spinners";


function ZonaCargando() {
    return (
        <div className="overlayCargando">
            <ClimbingBoxLoader color="var(--azul-ui)" size={15} />
        </div>
    )
}



export default ZonaCargando;